<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="addDetail" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.detail.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      p(v-if="parseFloat(detail.discount_quantity) > 0")
        slot(v-if="!checkDiscount") Obtén descuento de mayorista comprando {{ `${detail.discount_quantity} ${detail.unit_measurement}` }} o más
        slot(v-else) Haz desbloqueado el descuento de mayorista!
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("purchase_requisition_detail.product_placeholder")' v-model="detail.product" :label='$t("purchase_requisition_detail.product")' disabled)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(v-model="detail.quantity" autofocus :label='$t("purchase_requisition_detail.quantity")' :danger="!$v.detail.quantity.maxValue" :danger-text="'Quedan ' + detail.quantity_max + '' + ' piezas de este articulo'" :description-text="'Quedan ' + detail.quantity_max + '' +  detail.unit_measurement + ' de este articulo'" type="number")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(v-if="!checkDiscount" :placeholder='$t("purchase_requisition_detail.unit_price_placeholder")' v-model="detail.unit_price" :label='$t("purchase_requisition_detail.unit_price")' disabled)
          vm-input(v-else :placeholder='$t("purchase_requisition_detail.unit_price_placeholder")' :success="checkDiscount" v-model="detail.discount_price" :label='$t("purchase_requisition_detail.unit_price")' disabled)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("purchase_requisition_detail.unit_measurement_placeholder")' v-model="detail.unit_measurement" :label='$t("purchase_requisition_detail.unit_measurement")' disabled)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("purchase_requisition_detail.total_placeholder")' :success="checkDiscount" v-model="detail.total" :label='$t("purchase_requisition_detail.total")' disabled)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        br
        a(@click="openContactModal" id="contact_link") No hay existencia de este producto? Contáctanos
</template>
<script>
import { required, maxValue, minValue } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Pos')

export default {
  name: 'ModalPurchaseRequisitionsDetail',
  props: {
    detail: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    total: 0
  }),
  validations () {
    return {
      detail: {
        quantity: {
          required,
          minValue: minValue(0.01),
          maxValue: maxValue(this.maxValue)
        }

      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'isModalContactVisible',
      'inventoriesCatalog',
      'details'
    ]),
    getTitle () {
      return 'Agregar'
    },
    checkDiscount () {
      let qty = 0
      this.details[this.index] && (qty = parseFloat(this.details[this.index].quantity) + parseFloat(this.detail.quantity))
      return parseFloat(this.detail.quantity) >= parseFloat(this.detail.discount_quantity) || qty >= parseInt(this.detail.discount_quantity)
    },
    maxValue () {
      return this.detail.quantity_max ? this.detail.quantity_max : 0
    }
  },
  methods: {
    openContactModal () {
      this.setModalContactVisible(true)
      this.setModalVisible(false)
    },
    ...mapActions([
      'addPurchaseRequisitionDetail',
      'editPurchaseRequisitionDetail',
      'setModalVisible',
      'adjustTotal',
      'setModalContactVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      // this.isAdd ? this.addPurchaseRequisitionDetail(this.detail) : this.editPurchaseRequisitionDetail({ detail: this.detail, index: this.index })
    },
    async getCatalog () {
      // Object.keys(this.purchaseRequisitionsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    addDetail () {
      this.checkDiscount ? this.detail.hasDiscount = 1 : this.detail.hasDiscount = 0
      this.isAdd ? this.addPurchaseRequisitionDetail(this.detail) : this.editPurchaseRequisitionDetail({ detail: this.detail, index: this.index })
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
    },
    close () {
      this.setModalVisible(false)
    },
    setUnitPrice (value) {
      this.unit_price = value
    }
  },
  watch: {
    'detail.quantity' (quantity) {
      if (!this.checkDiscount) {
        this.detail.total = (parseFloat(this.detail.unit_price) * parseFloat(quantity)).toFixed(2)
      } else {
        this.detail.total = (parseFloat(this.detail.discount_price) * parseFloat(quantity)).toFixed(2)
        this.detail.discount_total = (parseFloat(this.detail.discount_price) * parseFloat(quantity)).toFixed(2)
      }
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
#contact_link {
  cursor: pointer;
}
</style>
